import type { EditorBlock, EditorPage } from "./editor.types";
import { isWork } from "../pages/pageMetadata";
import { blockService } from "../blocks";
import { newBlock } from "./document/documentModel";
import { saveDocument } from "./document/saveDocument";
export const appearsOnHome = (
  target: EditorPage,
  home: EditorPage | undefined,
  documents: Record<string, EditorBlock[]>,
) =>
  !!home &&
  (documents[home.id] ?? []).some(
    (b) =>
      b.block_type === "library" &&
      (((b.content as { mode?: string }).mode === "all" && isWork(target)) ||
        (documents[home.id] ?? []).some(
          (child) =>
            child.parent_source_block_id === b.source_block_id &&
            child.target_page_source_id === target.source_page_id,
        )),
  );
export async function setHomePlacement(
  home: EditorPage,
  target: EditorPage,
  pages: EditorPage[],
  show: boolean,
) {
  const previous = await blockService.list(home.id);
  let next = [...previous];
  const galleries = previous.filter((b) => b.block_type === "library");
  if (show) {
    let gallery = galleries[0];
    if (gallery && (gallery.content as { mode?: string }).mode === "all")
      return previous;
    if (!gallery) {
      gallery = newBlock(home, "library", {
        name: "Selected work",
        mode: "selected",
        layout: "grid",
        columns: 2,
        order: "manual",
      });
      gallery.position =
        Math.max(
          -1,
          ...previous
            .filter((b) => !b.parent_source_block_id)
            .map((b) => b.position),
        ) + 1;
      next.push(gallery);
    }
    if (
      !next.some(
        (b) =>
          b.parent_source_block_id === gallery.source_block_id &&
          b.target_page_source_id === target.source_page_id,
      )
    ) {
      const child = newBlock(home, "page", {
        display: "card",
        showDescription: true,
      });
      child.parent_source_block_id = gallery.source_block_id;
      child.target_page_source_id = target.source_page_id;
      child.position =
        Math.max(
          -1,
          ...next
            .filter((b) => b.parent_source_block_id === gallery.source_block_id)
            .map((b) => b.position),
        ) + 1;
      next.push(child);
    }
  } else {
    for (const gallery of galleries) {
      if ((gallery.content as { mode?: string }).mode === "all") {
        next = next.filter(
          (b) => b.parent_source_block_id !== gallery.source_block_id,
        );
        next = next.map((b) =>
          b.id === gallery.id
            ? {
                ...b,
                content: { ...(gallery.content as object), mode: "selected" },
              }
            : b,
        );
        pages
          .filter((p) => isWork(p) && p.id !== target.id)
          .forEach((p, position) => {
            const child = newBlock(home, "page", {
              display: "card",
              showDescription: true,
            });
            next.push({
              ...child,
              position,
              parent_source_block_id: gallery.source_block_id,
              target_page_source_id: p.source_page_id,
            });
          });
      } else
        next = next.filter(
          (b) =>
            !(
              b.parent_source_block_id === gallery.source_block_id &&
              b.target_page_source_id === target.source_page_id
            ),
        );
    }
  }
  // Every sibling group must remain contiguous after a removal.
  const positions = new Map<string, number>();
  next = next.map((b) => {
    const key = b.parent_source_block_id ?? "";
    const position = positions.get(key) ?? 0;
    positions.set(key, position + 1);
    return { ...b, position };
  });
  return saveDocument(home.id, previous, next);
}
